export default class Slider {
  constructor(element) {
    this.element = element;

    this.init();
  }

  init() {
    const io = new IntersectionObserver(observeImage);

    this.element.querySelectorAll('.js-slider-item').forEach((element) => io.observe(element));

    function observeImage(entries) {
      entries.forEach((element) => {
        if (element.isIntersecting) {
          const img = element.target.querySelector('img');

          if (img.dataset.src === '') {
            element.target.classList.remove('is-loading');
          } else {
            img.src = img.dataset.src;
          }

          img.onload = () => {
            element.target.classList.remove('is-loading');
          };

          io.unobserve(element.target);
        }
      });
    }
  }
}

/* This code toggles a pop-up window that shows a video. It also
   attaches event listeners to the background and the close button
   to close the window when they are clicked. */

const mediaContainers = document.querySelectorAll('.js-media__item-container');

// Find all media items and add event listeners
mediaContainers.forEach((mediaContainer) => {
   // Get the media pop up element
   const mediaPopUp = mediaContainer.querySelector('.js-media-pop-up');

   // Get the close button for the video
   const videoCloseButton = mediaPopUp.querySelector('.js-media-pop-up__video-close');

   // Get the background element
   const mediaBackground = mediaPopUp.querySelector('.js-media-pop-up__bg');

   // Hide the media pop up
   function toggleMediaPopUp() {
      mediaPopUp.classList.toggle('js-media-pop-up--hide');
   }

   // Stop the event from bubbling to the parent element
   function stopPropagation(event) {
      event.stopPropagation();
   }

   // Add event listener for hiding the media pop up when the background is clicked
   mediaBackground.addEventListener('click', toggleMediaPopUp);

   // Add event listener for hiding the media pop up when the close button is clicked
   videoCloseButton.addEventListener('click', (event) => {
      toggleMediaPopUp();
      stopPropagation(event);
   });

   // Add event listener for showing the media pop up when the media item is clicked
   mediaContainer.querySelector('.media__item').addEventListener('click', () => {
      toggleMediaPopUp();
   });
});
